import NavigationButton from '@components/NavigationButton'
import { Box, ButtonGroup, styled } from '@mui/material'

const NavItemGroup = styled(ButtonGroup)(({ theme }) => ({
  // A row of separate pills, so the group draws nothing of its own.
  border: 'none',
  gap: '0.5rem',
  boxShadow: 'none',

  [theme.breakpoints.down('md')]: {
    display: 'flex',
    justifyContent: 'center',
  },
}))

export type Route = {
  name: string
  isNav: boolean
  icon?: React.ReactNode
}

type NavButtonGroupProps = {
  onClick: (e: string) => void
  routes: Route[]
  selected: string
}

export default function NavigationButtonGroup({
  routes,
  onClick,
  selected,
}: NavButtonGroupProps) {
  return (
    <Box>
      <NavItemGroup variant="text" disableRipple aria-label="explorer sections">
        {routes.map((route) => (
          <NavigationButton
            key={route.name}
            text={route.name}
            icon={route.icon}
            onClick={onClick}
            // TODO: find a better way to determine active button
            isActive={route.name === selected}
          />
        ))}
      </NavItemGroup>
    </Box>
  )
}
